











































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  inject,
} from '@vue/composition-api'

import { previewTextbookIssue } from '@/shared/api'
import CloseButton from '@/components/custom/CloseButton.vue'
import { License, TextbookIssue } from '@/shared/types'
import { licensesSymbol } from '@/shared/state-management/symbols'

export default defineComponent({
  name: 'PreviewTextbookIssue',
  components: {
    CloseButton,
  },
  props: {
    textbookIssue: Object,
  },
  setup(props, { emit }) {
    const previewTextbookIssueForm = ref(null)
    const data = reactive({
      valid: true,
      licenses: [],
    })

    const loadingData = ref(false)
    const availableLicenses = inject(licensesSymbol) as { value: Array<string> }
    data.licenses = [...availableLicenses.value]

    const submit = async () => {
      const form = previewTextbookIssueForm.value
      if (!form.validate()) {
        return
      }
      loadingData.value = true
      try {
        await previewTextbookIssue(
          props.textbookIssue as TextbookIssue,
          data.licenses.map((license: License) => license.id)
        )
        emit('preview-textbook-issue')
        loadingData.value = false
      } catch (e) {
        loadingData.value = false
        throw e
      }
    }

    return {
      ...toRefs(data),
      loadingData,
      previewTextbookIssueForm,
      availableLicenses,
      submit,
    }
  },
})
